import algoliasearchHelper from 'algoliasearch-helper';
import * as Immutable from 'immutable';
import FacetType from "../records/FacetType";
import SearchParamsUpdate from "../records/SearchParamsUpdate";
import { resolveFacets, resolveSearchResults } from "./algoliaProcessors";
import enhanceFilters from "./enhanceFilters";
import resolveSearchParameters from "./resolveSearchParametersFromFilters";
import { resolveSearchIndex } from "./searchIndex";
import { resolveSortFromFilters } from "./sorting";
export function search({
  algoliaClient,
  environment,
  filters,
  numHits,
  page,
  applyOverrides,
  resolveAlgoliaQueryFilterOverrides,
  featureFlags
}) {
  const enhancedFilters = enhanceFilters(filters, featureFlags);
  const sort = resolveSortFromFilters({
    filters: enhancedFilters
  });
  const searchIndexToUse = resolveSearchIndex({
    environment,
    filters,
    sort
  });
  const searchParameters = resolveSearchParameters({
    applyOverrides,
    filters: enhancedFilters,
    index: searchIndexToUse,
    numHits,
    page,
    sort,
    resolveAlgoliaQueryFilterOverrides,
    featureFlags
  });
  return doSearch({
    algoliaClient,
    filters,
    index: searchIndexToUse,
    searchParameters,
    featureFlags
  });
}
export function getAppDetailsByAppKeys(algoliaClient, environment, appKeys) {
  const searchIndexToUse = resolveSearchIndex({
    environment
  });
  const searchParameters = {
    facetFilters: [appKeys.map(addonKey => "addonKey:".concat(addonKey))]
  };
  return algoliasearchHelper(algoliaClient, searchIndexToUse, {
    hitsPerPage: appKeys.length
  }).searchOnce(searchParameters);
}
function doSearch({
  algoliaClient,
  filters,
  index,
  searchParameters,
  featureFlags
}) {
  return new Promise((resolve, reject) => {
    algoliasearchHelper(algoliaClient, index).searchOnce(searchParameters).then(({
      content
    }) => {
      resolve(Immutable.Map({
        facets: resolveFacets({
          facets: Immutable.fromJS(content.facets).concat(Immutable.fromJS(content.disjunctiveFacets)),
          filters,
          featureFlags
        }),
        searchResults: resolveSearchResults({
          hits: Immutable.fromJS(content.hits),
          page: content.page,
          numberOfHits: content.nbHits,
          numberOfPages: content.nbPages
        })
      }));
    }, error => {
      reject(error.name === 'AlgoliaSearchJSONPScriptErrorError' ? {
        message: 'Connection error'
      } : error);
    });
  });
}
export function searchParamsUpdateForAddonKeys(addonKeys) {
  return new SearchParamsUpdate({
    types: Immutable.Set([FacetType.disjunctive('addonKey')]),
    apply: params => addonKeys.reduce((finalParams, key) => finalParams.addDisjunctiveFacetRefinement('addonKey', key), params)
  });
}
export function searchParamsUpdateForExcludingAddonKeys(addonKeys) {
  return new SearchParamsUpdate({
    types: Immutable.Set([FacetType.conjunctive('addonKey')]),
    apply: params => addonKeys.reduce((finalParams, key) => finalParams.addExcludeRefinement('addonKey', key), params)
  });
}